// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ledian: PokeData = {
  "id": 166,
  "name": "ledian",
  "height": 14,
  "weight": 356,
  "base_experience": 137,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "comet-punch",
    "tackle",
    "double-edge",
    "supersonic",
    "agility",
    "light-screen",
    "reflect",
    "swift",
    "mach-punch",
    "safeguard",
    "baton-pass",
    "silver-wind",
    "roost",
    "air-slash",
    "bug-buzz",
    "struggle-bug"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "reflect",
    "roost",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "brave-bird",
    "signal-spam",
    "string-shot",
    "infest",
    "aerial-ace",
    "chatter"
  ],
  "evolution_chain": {
    "id": 84,
    "item": null,
    "species": [
      {
        "name": "ledyba",
        "order": 197,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ledian",
        "order": 198,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 165,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 164,
    "ability_power": 106
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
